import { defineStore } from 'pinia'

export default defineStore({
  id: 'monitoringPage',
  persist: true,
  state: () => {
    return {
      vehicleFilters: {
        search: '',
        processStatus: '',
        vehicleType: ''
      },
      journeyFilters: {
        search: '',
        processStatus: '',
        vehicleType: '',
        scheduleType: '',
        processingType: ''
      },
      partnerSelected: {
        id: '',
        name: ''
      }
    }
  },
  getters: {
    getVehicleFilters: (state: any) => state.vehicleFilters,
    getJourneyFilters: (state: any) => state.journeyFilters,
    getSelectPartner: (state: any) => state.partnerSelected
  },
  actions: {
    clear: function () { },
    setVehicleFilters: function (payload: any) {
      Object.assign(this.vehicleFilters, payload || {})
    },
    setJourneyFilters: function (payload: any) {
      Object.assign(this.journeyFilters, payload || {})
    },
    selectPartner: function (payload: any) {
      if (this.partnerSelected === undefined) {
        this.partnerSelected = {
          id: '',
          name: ''
        }
      }
      Object.assign(this.partnerSelected, payload || {})
    }
  }
})
